/*
 * The category list of the storefront, as pure functions so they can be tested.
 * format-data.js feeds them the commerce API download and writes cats.json.
 *
 * The commerce API leaves hidden categories (Health & Spa) out of `GET
 * /categories` and out of the category groups of `/search`, although brands
 * are still tagged with them. data/extra-categories.json (committed) keeps the
 * ones the storefront sells anyway. They are appended here, so cats.json is the
 * one list every consumer reads. Once the API returns such a category itself,
 * its extra entry is skipped and the extra file has no effect.
 *
 * No dependencies: src/api.js imports this, so it ends up in the browser.
 */

const sameCategory = (a, b) => a.id === b.id || a.slug === b.slug;

/** API bookkeeping no consumer reads. */
const trim = ({ hidden, enabled, createdAt, updatedAt, ...category }) => category;

/** The extra categories the API list does not already contain (by id or slug). */
const missingCategories = (apiCategories = [], extraCategories = []) =>
  extraCategories.filter(
    (extra, index) =>
      !apiCategories.some((category) => sameCategory(category, extra)) &&
      // An extra listed twice counts once.
      extraCategories.findIndex((other) => sameCategory(other, extra)) === index
  );

/**
 * Every category of the storefront: the API's, in the API's order, then the
 * extra ones it hides. No category appears twice, so merging an already merged
 * list (src/api.js does, in case cats.json is older than this script) is a no-op.
 */
const mergeCategories = (apiCategories = [], extraCategories = []) =>
  [...apiCategories, ...missingCategories(apiCategories, extraCategories)].map(trim);

module.exports = { mergeCategories, missingCategories };
